import { useMemo } from 'react'

import { useNavigate, useParams } from 'react-router'

import { VideoPlayer } from '@/components/ui/video-player.tsx'
import { AppRoutes } from '@/utils/constants'

import { courseVideos } from '../../data/course-videos.ts'
import { useCourse } from '../../hooks/useCourse'
import { SwitchCategoryButtons } from './SwitchCategoryButtons'
import { VideoItem } from './VideoItem'

export const Course = () => {
  const { setCurrentVideo, currentVideoId } = useCourse()
  const { category } = useParams()
  const navigate = useNavigate()

  const handleVideoItemClick = (id: string) => () => {
    setCurrentVideo(id)
  }

  const switchToNextVideo = () => {
    const categoryVideos = courseVideos.find(
      (video) => video.name === category,
    )?.videos

    if (categoryVideos) {
      const currentVideoIndex = categoryVideos?.findIndex(
        (video) => video.video_id === currentVideoId,
      )
      const categoryVideosIndex = courseVideos.findIndex(
        (video) => video.name === category,
      )

      // for last video of last category playlist
      if (
        categoryVideosIndex === courseVideos.length - 1 &&
        currentVideoIndex === categoryVideos.length - 1
      ) {
        return
      }
      // for last video of category playlist
      if (currentVideoIndex === categoryVideos.length - 1) {
        setCurrentVideo(
          courseVideos[categoryVideosIndex + 1].videos[0].video_id,
        )
        navigate(
          AppRoutes.Courses.Details.asUrl(
            courseVideos[categoryVideosIndex + 1].name,
          ),
        )

        return
      }
      // default switch
      setCurrentVideo(categoryVideos[currentVideoIndex + 1].video_id)
    }
  }

  const categoryVideos = useMemo(
    () =>
      courseVideos.find((categoryVideo) => categoryVideo.name === category)
        ?.videos,
    [category],
  )

  const currentVideo = useMemo(() => {
    const categoryVideos = courseVideos.find(
      (categoryVideo) => categoryVideo.name === category,
    )?.videos

    return categoryVideos?.find((video) => video.video_id === currentVideoId)
  }, [category, currentVideoId])

  return (
    <div className="flex flex-col gap-6 overflow-hidden">
      <div className="flex flex-col gap-4 rounded-2xl bg-card p-8 max-sm:p-4">
        <h4 className="text-xl font-semibold text-title">
          {currentVideo?.title}
        </h4>
        <div className="flex flex-col rounded-2xl xl:flex-row">
          {currentVideoId && (
            <VideoPlayer
              videoId={currentVideoId}
              onVideoEnds={switchToNextVideo}
            />
          )}

          <div className="flex max-h-[500px] min-w-[25vw] flex-col gap-3 overflow-y-scroll bg-card p-2 py-5 xl:px-4 xl:py-0">
            {categoryVideos?.map((video) => (
              <VideoItem
                key={video.video_id}
                duration={video.duration}
                image={video.thumbnail}
                title={video.title}
                date={video.date}
                isActive={video.video_id === currentVideoId}
                onClick={handleVideoItemClick(video.video_id)}
              />
            ))}
          </div>
        </div>
      </div>
      <SwitchCategoryButtons />
    </div>
  )
}
